<template>
    <div class="mui-content">
		<div class="pd20">
			<h3 class="loginTitle">输入验证码</h3>
			<p class="codeInfo">验证码已发送至 {{phoneInfo.tel}}，30分钟内有效</p>
			<div class="mui-input-row">
				<input type="text" class="muiInput" placeholder="验证码" autocomplete="off" 
					id="tel" maxlength="6"/>
				<div class="sendCode disabled" id='codeBtn' disabled='disabled' @click="againSend()">60s后重新获取</div>
				<br></br>
			</div>
			
			<button type="button" class="mui-btn mui-btn-primary mui-btn-block mui-disabled"
				id="getCode">登录</button>
			<p><a @click="toNoCode()" style="color: #ccc;"><small>收不到验证码?</small></a></p>
		</div>
	</div>	
</template>

<script>
	import { ChangePwdSendSMS,BindingPhone} from '@/request/api';
    export default{
    	data: function(){
			return {
				phoneInfo:{},
				InterValObj:'',
				count:60 , //间隔函数，1秒执行 
         		curCount:10,
			}
		},
    	created () {
    		this.phoneInfo = this.$route.query ;
//  		console.log(this.phoneInfo);
			this.lastTime();
		},
		mounted(){
			$("#tel").bind('input',function(){
				var tel = $(this).val();
				if(tel){
					$("#getCode").removeClass("mui-disabled");
				}else{
					$("#getCode").addClass("mui-disabled")
				}
			});
			var _this = this;
			$("#getCode").click(function(){
				var tel = $("#tel").val();
				if(tel == _this.phoneInfo.msgCode){
					//验证码正确的情况下，需要绑定用户。
					BindingPhone({     
				    	"phone": _this.phoneInfo.tel,     
				    	"openid":_this.phoneInfo.openid
				   	}).then(res => {
				    	// 获取数据成功后的其他操作
				    	if(res.result =='true'){
				    		mui.toast('验证成功',{ duration:'long'});
				    		sessionStorage.setItem("tenant_id",res.UserKey);
							_this.$router.push({path: '/home'});
				    	}
				    	else{
				    		mui.toast(res.description,{ duration:'long'});	
				    	}
			  		})  
				}else{
					mui.toast('验证码错误，请重新输入',{ duration:'long'});	
				}
			});
		},
    	methods:{
    		lastTime(){
    			this.curCount = this.count;
    			$("#codeBtn").attr("disabled", "true");
				$("#codeBtn").addClass('disabled');
		        var _this = this;
	           	this.InterValObj = setInterval(_this.setRemainTimes, 1000); //启动计时器，1秒执行一次 
    		},
    		setRemainTimes(){
//  			console.log('adsda')
    			if(this.curCount == 0) {
	               clearInterval(this.InterValObj); //停止计时器 
	               $("#codeBtn").removeAttr("disabled"); //启用按钮 
	               $("#codeBtn").html("重新发送验证码");
	               $("#codeBtn").removeClass("disabled");
//	               code = ""; //清除验证码。如果不清除，过时间后，输入收到的验证码依然有效   
	            } else {
	               this.curCount--;
	               $("#codeBtn").html(this.curCount + "s后重新获取");
	            }
    		},
    		againSend(){
    			if(!$("#codeBtn").hasClass("disabled")){
	    			//再次发送验证码
	    			var _this = this;
	    			ChangePwdSendSMS({     
				    	"phone": _this.phoneInfo.tel,     
				   	}).then(res => {
				    	// 获取数据成功后的其他操作
				    	if(res.result =='true'){
				    		_this.phoneInfo.msgCode = res.UserKey;
				    		_this.lastTime();
				    	}
				    	else{
				    		mui.toast(res.description,{ duration:'long'});	
				    	}
			  		})  
		  		}
    		},
        	toNoCode(){
        		this.$router.push({path: '/noCode'});
        	}
        }
    }
</script>
<style>
     @import '../common/css/public.css';
</style>


// WEBPACK FOOTER //
// src/pages/sendCode.vue